import {ActionType} from '@typescript/common/actionTypes';
import {MENU} from 'constants/actions';
import {OPEN_MENU_ITEMS_TO_OPEN, VisibilityMenuType} from 'reducers/menu/visibilityMenuType';

/**
 * Action for set visibility main menu
 * @param {boolean} visible - state visible menu
 * @param {string} openMenuItem - state openMenuItem menu
 * @returns {ActionType<VisibilityMenuType>} Action
 */
export function visibilityMenu(
    visible: boolean,
    openMenuItem: VisibilityMenuType['openMenuItem'] = OPEN_MENU_ITEMS_TO_OPEN.DEFAULT,
): ActionType<VisibilityMenuType> {
    return {
        type: MENU.SET_VISIBILITY_MENU,
        payload: {
            visible,
            openMenuItem,
        },
    };
}
